import { action } from "../common/Action"
import { InterventiClient } from "../generated";

const service = new InterventiClient();

class TipiCombustibileActions {
    @action
    async getAll() {
        return (await service.getTipiIntervento())!;

    };
}
export default new TipiCombustibileActions();